import { openBlock as n, createElementBlock as t, createElementVNode as o } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function l(c, e) {
  return n(), t("svg", r, [...e[0] || (e[0] = [
    o("path", {
      fill: "currentColor",
      d: "M13 7h-2v6h2zm-1 15c5.52 0 10-4.48 10-10S17.52 2 12 2 2 6.48 2 12s4.48 10 10 10m0-18c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8m1 11h-2v2h2z"
    }, null, -1)
  ])]);
}
const m = { render: l };
export {
  m as default,
  l as render
};
